export const BaseKioskTheme = {
    name: 'default',
    favicon: '/assets/img/theme/default/Fav-Icon-Gomoto.ico',
    internalBackgroundKiosk: '/assets/img/theme/default/Internal-Bkgd-Kiosk-GoMoto.jpg',
    landingPageBannerKiosk: '/assets/img/theme/default/LP-Banner-Kiosk-GoMoto-Default.jpg',
    landingPageBackgroundKiosk: '/assets/img/theme/default/LP-Bkgd-Kiosk-Default.png',
    internalBannerMobile: '/assets/img/theme/default/Internal-Banner-Mobile-GoMoto-Default.jpg',
    landingPageBannerMobile: '/assets/img/theme/default/LP-Banner-Mobile-GoMoto-Default.jpg',
    kioskLogo: '/assets/img/theme/default/GoMoto-Logo-Kiosk.png',
    mobileLogo: '/assets/img/theme/default/GoMoto-Logo-Mobile.png',
};